module.exports = __webpack_public_path__ + "static/media/fmcg-3.d4fe9f91.png";